import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ProjectBlockItem from 'shared/components/likiee/ProjectBlockItem';

const ProjectsTab = ({ userId, projects }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const onProjectClick = project => {
    history.push(`/user/${userId}/project/${project.id}`);
  };

  return (
    <div>
      <div className='d-flex row flex-wrap px-4 px-md-0'>
        {projects.map((item, i) => {
          return <ProjectBlockItem item={item} key={i} onProjectClick={onProjectClick.bind(null, item)} />;
        })}
      </div>
      {!projects?.length && <p className='col-12 mt-3  text-center text-secondary'>{t('project_no_result')}</p>}
    </div>
  );
};

export default ProjectsTab;
